'use client'

import { forwardRef, useCallback, useMemo } from 'react'

import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from '@/components/common/Select'

import { setDateByType } from '@/helpers/date'

export interface MinuteSelect {
  value: Date | undefined
  setValue: (value: Date) => void
}

export const MinuteSelect = forwardRef<HTMLButtonElement, MinuteSelect>(
  ({ value, setValue }, ref) => {
    const handleValueChange = useCallback(
      (minute: string) => {
        const tempDate = value ? new Date(value) : new Date()
        setValue(setDateByType(tempDate, minute, 'minutes'))
      },
      [value, setValue],
    )

    const minute = useMemo(() => {
      return value?.getMinutes().toString().padStart(2, '0') || '00'
    }, [value])

    return (
      <div className="flex items-center">
        <Select value={minute} onValueChange={handleValueChange}>
          <SelectTrigger ref={ref} className="w-full h-8">
            <SelectValue>{minute}</SelectValue>
          </SelectTrigger>
          <SelectContent>
            {[...Array(60)].map((_, i) => {
              const minute = i.toString().padStart(2, '0')
              return (
                <SelectItem key={minute} value={minute}>
                  {minute}
                </SelectItem>
              )
            })}
          </SelectContent>
        </Select>
      </div>
    )
  },
)

MinuteSelect.displayName = 'MinuteSelect'
